import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';

const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Button, Form, FormField, Input, Link, Modal, SpaceBetween, Spinner, Table, Toggle } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiDrawPen, mdiEyeOffOutline, mdiEyeOutline, mdiSignature, mdiSignatureFreehand } from '@mdi/js';
import { Icon } from '@mdi/react';
import ConfirmDelete from '../../../../components/extras/ConfirmDelete';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setData, setLoading } from '../../../commons/functions';


import FroalaEditorComponent from 'react-froala-wysiwyg';

import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/table.min.css';
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/code_beautifier.min.js";
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/quick_insert.min.js";
import "froala-editor/js/plugins/quote.min.js";
import "froala-editor/js/plugins/table.min.js";
import React from 'react';
import SelectGroup from '../../../../components/selects/selectGroups';
import SelectUserType from '../../../../components/selects/selectUserTypes';
import { ItemACK } from '../../../../resources/types';



export const CommTakeNotesPage = () => {
    //const storeAdmin = useStoreAdmin();

    useGlobalState();
    const { navigate } = useRouter();

    const { idUser, data, menu } = useGlobalState();


    const [idUsers, setIdUsers] = useState<number[]>([]);
    const [ACKs, setACKs] = useState<ItemACK[]>([]);
    const [idACK, setIdACK] = useState<number>(0);
    const [ACK, setACK] = useState<ItemACK>();
    const [ACKSign, setACKSign] = useState<ItemACK>();
    const [showSignature, setShowSignature] = useState(false);
    const [count, setCount] = useState(0);
    const editorRef = useRef<any>(null);
    const handlePaste = async (clipboardEvent: ClipboardEvent) => {

        const items = clipboardEvent.clipboardData?.items;
        if (!items) return;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.type.indexOf("image") === 0) {
                const file = item.getAsFile();
                if (!file) return;

                clipboardEvent.preventDefault();
                clipboardEvent.stopPropagation();
                // 1. Convert to Base64
                const reader = new FileReader();
                reader.onload = async (e) => {
                    const base64Data = e.target?.result as string;

                    try {
                        // 2. Upload to server
                        const response = await fetch(`${getUrlVersion()}/resources/images/ackimage`, {
                            method: "POST",
                            body: JSON.stringify({
                                file: base64Data.split(',')[1],
                                name: file.name,
                                type: file.type,
                                id: Date.now().toString()
                            }),
                            headers: { "Content-Type": "application/json" }
                        });

                        const result = await response.json();
                        const imageUrl = result.url || result;

                        const editor = editorRef.current?.editor;

                        if (editor) {
                            // Insert the image HTML
                            editor.html.insert(`<img src="${imageUrl}" />`);

                            // Focus the editor after insertion
                            editor.events.focus();
                        }

                        // 4. Trigger synchronization
                        editorRef.current?.editor.events.trigger('contentChanged');
                    } catch (error) {
                        console.error("Upload failed", error);
                    }
                };

                reader.readAsDataURL(file);
                return false;
            }
        }
    };
    const handleSignature = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/takenote/sign',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                addNotificationStatus(data, setData);
                if (data.code === 0 && data.ACKs) {
                    navigate(`members/etc/takenote`);
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetSignatures = async (idACK: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/acks/ack',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0 && data.ACK) {
                    //setACK(data.ACK)
                    setACKSign(data.ACK)
                    setIdUsers([...new Set([...data.ACK.isSignACK, ...data.ACK.isReadACK])])
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleGetACK = async (idACK: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/acks/ack',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({ idACK: idACK, isActiveACK: -1 })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                addNotificationStatus(data, setData);
                if (data.code === 0 && data.ACK) {
                    setACK(data.ACK)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }
    const handleUpdateACKActive = async (ACK: ItemACK, isActiveACK: number) => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/acks/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    idACK: ACK.idACK,
                    isActiveACK: isActiveACK,
                    columns: "idACK, fechaACK, isActiveACK, isReadACK2, isSignACK2"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                handleGetACKs()
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setACKs(prevACKs => prevACKs.map(ack => ack.idACK === ACK.idACK ? { ...ACK } : ack));

        }
    };
    const handleCount = async () => {
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/users.count',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    ...(ACK.idGroups?.length > 0 && { idGroups: ACK.idGroups }),
                    ...(ACK.idUserTypes?.length > 0 && { idUserTypes: ACK.idUserTypes }),
                    intersection: 1
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                if (data.code === 0 && !!data.count) {
                    setCount(data.count)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdateTakeReason = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/acks/update',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    idACK: ACK.idACK, idGroups: ACK.idGroups, idUserTypes: ACK.idUserTypes, ACK: ACK.ACK, ACKTitle: ACK.ACKTitle,
                    columns: "idACK, fechaACK, isActiveACK, isReadACK2, isSignACK2, ACKTitle"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data) {
                addNotificationStatus(data, setData);
                if (data.code === 0) {
                    window.location.hash = "comm/takenotes"
                    setACK(undefined)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleGetACKs = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/acks/list',
                    'JWT': getCookie("JWT"),

                },

                body: JSON.stringify({
                    columns: "idACK, fechaACK, isActiveACK, isReadACK2, isSignACK2, ACKTitle",
                    orderBy: "fechaACK", order: "desc"
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data) {
                if (data.code === 0 && data.ACKs) {
                    setACKs(data.ACKs)
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id === null)
                setIdACK(0);
            else
                setIdACK(parseInt(id));
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {
        if (idACK > 0) {
            handleGetACK(idACK);
        } else {
            setACK(undefined);
            handleGetACKs();
        }
    }, [idACK]);
    useEffect(() => {
        if (!!ACK) {
            handleCount();
        }
    }, [ACK?.idGroups, ACK?.idUserTypes]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<>
                        {ACK ? <Button variant='link' onClick={() => { navigate('comm/takenotes'); setACK(undefined) }}>Volver al listado</Button> : null}
                        <Favorites /></>}
                    >Tomas de razón</Header>
                    {ACK && (
                        <>
                            {ACK.isSignACK.length === 0 ?
                                <Form header={<Header variant="h2" description={ACK.fechaACK !== '' ? `Fecha de emsión ${ACK.fechaACK}` : ''}>{ACK.idACK > 0 ? `Editar toma de razón #${ACK.idACK}` : `Crear toma de razón`}</Header>}
                                    secondaryActions={<>Total usuarios: <strong>{count}</strong></>}
                                    actions={
                                        <Button variant="primary" onClick={() => {
                                            handleUpdateTakeReason()

                                        }}>{ACK.idACK === 0 ? "Crear" : "Actualizar"}</Button>
                                    }
                                >
                                    <SpaceBetween direction="vertical" size="xs">
                                        <FormField label="Título">
                                            <Input value={ACK.ACKTitle} onChange={({ detail }) => setACK({ ...ACK, ACKTitle: detail.value })} />
                                        </FormField>
                                        <SpaceBetween direction="horizontal" size="xs">
                                            <FormField label="Tipos de socios">
                                                <SelectUserType single={false} value={ACK.idUserTypes}
                                                    onSelect={(userTypes) => {
                                                        setACK({
                                                            ...ACK,
                                                            idUserTypes: userTypes
                                                        })
                                                    }} />
                                            </FormField>
                                            <FormField label="Grupos">
                                                <SelectGroup single={false} value={ACK.idGroups}
                                                    onSelect={(groups) => {
                                                        setACK({
                                                            ...ACK,
                                                            idGroups: groups
                                                        })
                                                    }} />
                                            </FormField>
                                        </SpaceBetween>
                                        <div style={{ marginTop: 15 }}>
                                            <FroalaEditorComponent
                                                ref={editorRef}
                                                key={"ACTIVATION_KEY"}
                                                tag="textarea"
                                                onModelChange=
                                                {(model: any) => setACK({ ...ACK, ACK: model })}
                                                model={ACK.ACK || ""}
                                                config={{

                                                    imageUpload: false,
                                                    imagePaste: false,
                                                    pastePlain: true,
                                                    useClasses: false,
                                                    events: {
                                                        initialized: function () {
                                                            const editorEl = editorRef.current?.editor?.$el[0];
                                                            editorEl?.addEventListener("paste", handlePaste);
                                                            if (editorEl) {

                                                            }
                                                        },
                                                    },
                                                    toolbarButtons: [
                                                        "clearFormatting", "alert", "undo", "redo", "blockquote", "bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "lineHeight", "outdent", "indent", "insertLink", "insertImage", "insertVideo", "insertTable", "insertHR", "selectAll", "html", "help",
                                                    ],
                                                    pluginsEnabled: [
                                                        "paragraphStyle", "image", "codeView", "paste", "align", "table", "lists", "link", "clearFormatting", "quote",
                                                    ],
                                                }}
                                            />
                                        </div>
                                    </SpaceBetween>
                                </Form>
                                :
                                (<SpaceBetween direction='vertical' size='xs'>
                                    <Header variant="h2"
                                        actions={ACK.fechaACK}
                                    >{ACK.ACKTitle}</Header>
                                    <div dangerouslySetInnerHTML={{ __html: ACK.ACK || "" }} />
                                </SpaceBetween>)
                            }
                        </>
                    )}

                    {!ACK && (
                        <Table
                            header={<Header variant="h2" actions={
                                <Button variant="primary" onClick={() => {
                                    setACK({ ACKTitle: "", idACK: 0, isActiveACK: 1, ACK: '', fechaACK: '', isReadACK: [], isSignACK: [], idUserTypes: [], idGroups: [] });

                                }}>Crear</Button>
                            } />}
                            stickyHeader
                            variant='embedded'
                            columnDefinitions={[
                                {
                                    id: 'ACK',
                                    header: 'TDR/Fecha',
                                    cell: (item) => <FormField label={<Link href={`#comm/takenotes?id=${item.idACK}`}>{item.ACKTitle}</Link>}
                                        constraintText={item.fechaACK}
                                    />,
                                    minWidth: 400,
                                },
                                {
                                    id: 'Firmada',
                                    header: 'Firmada',
                                    cell: (item) =>
                                        item.isSignACK.includes(idUser) ? (
                                            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                Firmada <Icon path={mdiSignatureFreehand} size={1} />
                                            </span>
                                        ) : (
                                            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                Pendiente de firma <Icon path={mdiSignature} color="red" size={1} />
                                            </span>
                                        ),
                                    width: 300,
                                },
                                {
                                    id: 'Firmantes',
                                    header: 'Firmantes',
                                    cell: (item) => item.isSignACK.length === 0 ? (<b>-----</b>) : <Link onClick={() => handleGetSignatures(item.idACK)}>{item.isSignACK.length > 0 ? item.isSignACK.length : 0}</Link>,
                                    width: 200,
                                },
                                {
                                    id: 'isActiveACK',
                                    header: 'Activa',
                                    cell: (item) =>
                                        <SpaceBetween direction="horizontal" size="xs">
                                            {item.loading ?

                                                <Spinner variant="normal" /> :
                                                <Toggle
                                                    disabled={item.isSignACK.length > 0}
                                                    checked={item.isActiveACK === 1}
                                                    onChange={() => {
                                                        setACKs(prevACKs => prevACKs.map(ack => ack.idACK === item.idACK ? { ...ack, loading: true, isActiveACK: ack.isActiveACK === 1 ? 0 : 1 } : ack));
                                                        handleUpdateACKActive(item, item.isActiveACK === 1 ? 0 : 1)
                                                    }}

                                                    ariaLabel="Activo/Inactivo"
                                                />
                                            }
                                        </SpaceBetween>
                                    ,
                                    width: 200,
                                }

                            ]}
                            items={ACKs}
                            loadingText="Loading ACKs..."
                        />
                    )}
                    <ConfirmDelete show={showSignature} confirmWord={'firmar'} action={'Firmar'} warning={'Para continuar utilizando el sitio web, debe leer y firmar la toma de razón'} header={`Toma de razón #${ACK?.idACK}`} onConfirm={() => { handleSignature(); setShowSignature(false) }} onDismiss={() => setShowSignature(false)} />

                    <Modal visible={idUsers.length > 0} onDismiss={() => setIdUsers([])} closeAriaLabel="Close modal"
                        header={`Usuarios que han interactuado con la toma de razón #${ACKSign?.idACK}`}
                    >
                        <Table
                            stickyHeader
                            variant="borderless"
                            columnDefinitions={[
                                {
                                    id: 'idUser',
                                    header: 'Usuario',
                                    cell: (item) => getUser(item, data)?.displayName || `${item} Usuario no encontrado`,
                                    width: 150,
                                }, {
                                    id: 'read',
                                    header: 'Estado',
                                    width: 70,
                                    cell: (item) =>
                                        <SpaceBetween direction='horizontal' size="xs">
                                            {ACKSign?.isReadACK?.includes(item) ? <Icon path={mdiEyeOutline} size={1} /> : <Icon path={mdiEyeOffOutline} size={1} color={"red"} />}

                                            {ACKSign?.isSignACK?.includes(item) ? <Icon path={mdiDrawPen} size={1} /> : <Icon path={mdiSignature} size={1} color={"red"} />}
                                        </SpaceBetween>,

                                }

                            ]}
                            items={idUsers}
                            loadingText="Loading users..."
                        />

                    </Modal>
                </SpaceBetween>
            }
        />
    );
};
